/**
 * @interface RaceEntryRepository
 * Race entries are stored as an embedded array in the resume document.
 * These methods operate on that embedded array.
 */
export class RaceEntryRepository {
  /** @returns {Promise<RaceEntry>} */
  async add(resumeId, raceEntry) { throw new Error('Not implemented'); }

  /** @returns {Promise<void>} */
  async update(resumeId, raceId, data) { throw new Error('Not implemented'); }

  /** @returns {Promise<void>} */
  async delete(resumeId, raceId) { throw new Error('Not implemented'); }

  /** @returns {Promise<RaceEntry[]>} */
  async getByResumeId(resumeId) { throw new Error('Not implemented'); }
}
